import React from "react";
import { motion } from "framer-motion";
import { Users, ShieldCheck, Sparkles, Headphones, MessagesSquare, Award } from "lucide-react";

const reasons = [
  {
    icon: Users,
    title: "Un equipo especializado",
    text: "Somos un equipo dedicado exclusivamente a la importación de vehículos desde Alemania. Te acompañamos desde la búsqueda hasta la entrega en España.",
  },
  {
    icon: ShieldCheck,
    title: "Compromiso real",
    text: "No vendemos coches: defendemos tus intereses. Nuestro éxito se mide por tu satisfacción y la calidad del vehículo que recibes.",
  },
  {
    icon: Sparkles,
    title: "Experiencia premium",
    text: "Atención cuidada, respuestas rápidas y un trato cercano en cada decisión importante del proceso.",
  },
  {
    icon: Headphones,
    title: "Acompañamiento profesional",
    text: "Resolvemos tus dudas en cada paso. No te quedas solo frente a la negociación, la inspección o la documentación.",
  },
  {
    icon: MessagesSquare,
    title: "Comunicación clara",
    text: "Te explicamos cada fase con un lenguaje sencillo, sin tecnicismos innecesarios. Sabes qué pasa y por qué pasa.",
  },
  {
    icon: Award,
    title: "Estándar alemán",
    text: "Aplicamos el rigor del mercado alemán al servicio. Documentación impecable, plazos claros y entrega cuidada.",
  },
];

export const WhyElecars = () => {
  return (
    <section
      id="por-que-elecars"
      className="relative py-24 sm:py-32 bg-[#0A0A0A] border-t border-white/5"
      data-testid="why-elecars-section"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8 }}
            className="lg:col-span-5 lg:sticky lg:top-32"
          >
            <span className="text-xs uppercase tracking-[0.32em] text-[#D4AF37]">Por qué Elecars</span>
            <h2 className="font-heading mt-6 text-3xl sm:text-5xl font-light tracking-tight text-[#FFFFF0] leading-[1.08]">
              Un equipo, no una intermediación.
            </h2>
            <p className="mt-6 text-base text-[#A3A3A3] leading-relaxed font-light">
              Somos un equipo especializado que acompaña al cliente desde la búsqueda hasta la entrega del vehículo en España. Trabajamos contigo, no por encima de ti.
            </p>

            <div className="mt-10 inline-flex items-center gap-3 border border-white/10 bg-white/[0.03] px-5 py-3">
              <span className="w-2 h-2 bg-[#25D366] rounded-full animate-pulse" />
              <span className="text-xs uppercase tracking-[0.2em] text-[#FFFFF0]">Disponibles ahora</span>
            </div>
          </motion.div>

          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-px bg-white/5 border border-white/5">
            {reasons.map((r, i) => (
              <motion.div
                key={r.title}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.6, delay: i * 0.07 }}
                className="group bg-[#0A0A0A] p-7 sm:p-8 hover:bg-[#141414] transition-colors duration-500"
                data-testid={`why-elecars-card-${i}`}
              >
                <div className="w-11 h-11 border border-[#D4AF37]/30 bg-[#D4AF37]/5 flex items-center justify-center mb-5 group-hover:bg-[#D4AF37]/15 transition-colors">
                  <r.icon className="w-5 h-5 text-[#D4AF37]" strokeWidth={1.3} />
                </div>
                <h3 className="font-heading text-base sm:text-lg font-medium text-[#FFFFF0] mb-2 leading-snug">{r.title}</h3>
                <p className="text-sm text-[#A3A3A3] leading-relaxed font-light">{r.text}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyElecars;
